module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.7fb0e3780372f10f804513e2e0c39e78.woff2";